/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_No_Master_ResumeInputs */

const en_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No master resume found. Create a resume and mark it as master first.`)
};

const de_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Master-Lebenslauf gefunden. Erstelle einen Lebenslauf und markiere ihn zuerst als Master.`)
};

const fr_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun CV principal trouvé. Crée un CV et marque-le comme principal d'abord.`)
};

const es_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró currículum principal. Cree un currículum y márquelo como principal primero.`)
};

const it_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun curriculum principale trovato. Crea un curriculum e impostalo come principale.`)
};

const nl_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen master-CV gevonden. Maak een CV aan en markeer het als master.`)
};

const pl_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono głównego CV. Utwórz CV i ustaw je jako główne.`)
};

const fi_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pääansioluetteloa ei löytynyt. Luo ansioluettelo ja aseta se pääversioksi.`)
};

const da_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intet master-CV fundet. Opret et CV og markér det som master først.`)
};

const sv_jobs_no_master_resume = /** @type {(inputs: Jobs_No_Master_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget huvud-CV hittat. Skapa ett CV och markera det som huvud först.`)
};

/**
* | output |
* | --- |
* | "No master resume found. Create a resume and mark it as master first." |
*
* @param {Jobs_No_Master_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_no_master_resume = /** @type {((inputs?: Jobs_No_Master_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_No_Master_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_no_master_resume(inputs)
	if (locale === "fr") return fr_jobs_no_master_resume(inputs)
	if (locale === "es") return es_jobs_no_master_resume(inputs)
	if (locale === "it") return it_jobs_no_master_resume(inputs)
	if (locale === "nl") return nl_jobs_no_master_resume(inputs)
	if (locale === "pl") return pl_jobs_no_master_resume(inputs)
	if (locale === "fi") return fi_jobs_no_master_resume(inputs)
	if (locale === "da") return da_jobs_no_master_resume(inputs)
	if (locale === "sv") return sv_jobs_no_master_resume(inputs)
	return en_jobs_no_master_resume(inputs)
});